import { Divider, Stack, Typography } from '@mui/material';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { UploadPrescription } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { differenceInDays } from 'date-fns';
import {
  IMedicationRecommendation,
  IRecommendations,
} from 'API/Home/recommendations';

interface IMedicationList {
  data: IRecommendations;
}

export const MedicationList = ({ data }: IMedicationList) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).remindYou;

  const daysRemaining = (nextRefreshDate: Date) => {
    const today = new Date();
    const refreshDate = new Date(nextRefreshDate);
    const difference = differenceInDays(refreshDate, today);
    return Math.max(0, difference);
  };

  return (
    <Stack
      p={'40px 32px 48px'}
      bgcolor={'white'}
      height={'100%'}
      borderRadius={'16px'}
      justifyContent={'space-between'}
    >
      <Stack gap={'24px'}>
        <Typography variant='h5'>
          {dictionary.youHave} <strong>{data.entityJSON.items.length}</strong>{' '}
          {dictionary.medicationsToRenew}
        </Typography>
        <Stack gap={'8px'}>
          {data.entityJSON.items.map((medication) => (
            <Stack>
              <Stack
                flexDirection='row'
                justifyContent='space-between'
                p='20px 0'
              >
                <Typography variant='body3'>
                  {medication.medicatioN_NAME}
                </Typography>
                <Typography variant='body5'>
                  {medication.nextrefreshdate &&
                    dictionary.daysRemaining(
                      daysRemaining(medication.nextrefreshdate)
                    )}
                </Typography>
              </Stack>
              <Divider
                flexItem
                sx={{ borderColor: 'primary.shade_100' }}
                aria-hidden='true'
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
      <OneOrTwoButtons
        width='max-content'
        leftButton={{
          label: dictionary.requestPrescription,
          onClick: () => {},
        }}
        rightButton={{
          label: dictionary.uploadNewPrescription,
          onClick: () => {},
          icon: UploadPrescription,
        }}
      />
    </Stack>
  );
};
